import React, { Fragment } from 'react';
import AccountStatementListBrowser from './AccountStatementListBrowser';
import PropTypes from 'prop-types';
import HeaderPortal from 'components/layout/HeaderPortal';
import HeaderLinks from './header/HeaderLinks';
import Portal from 'utils/portal/Portal';
import { withAreaGetter } from 'providers/AreasConsumers';
import { areas } from 'constants/areas';
import useHistoryWithContext from 'components/menu/useHistoryWithContext';
import { usePermission } from 'providers/RightsHooks';
import { ADMIN_ACCOUNT_STATEMENT_READ, ADMIN_ACCOUNT_STATEMENT_WRITE } from 'constants/rightsCodes';
import PermissionCheck from 'components/common/PermissionCheck';

const Route = ({ getElemByAreaKey }) => {
  const historyContext = useHistoryWithContext();

  const canWrite = usePermission(ADMIN_ACCOUNT_STATEMENT_WRITE);

  const onAdd = () => {
    historyContext.push(`/accountStatement/new`);
  };

  return (
    <Fragment>
      <HeaderPortal />
      <Portal container={getElemByAreaKey(areas.headerLinks)}>
        <PermissionCheck authorizationCode={ADMIN_ACCOUNT_STATEMENT_WRITE} withForbiddenPage={false}>
          <HeaderLinks onAdd={onAdd} />
        </PermissionCheck>
      </Portal>
      <PermissionCheck authorizationCode={ADMIN_ACCOUNT_STATEMENT_READ}>
        <AccountStatementListBrowser canWrite={canWrite} />
      </PermissionCheck>
    </Fragment>
  );
};

Route.propTypes = {
  getElemByAreaKey: PropTypes.func.isRequired
};

export default withAreaGetter(Route);
